<template>
    <v-container fluid fill-height style="background-color: #1D4A91">
        <v-layout justify-center row pa-5>
            <v-flex xs12 sm10 md6>
                <v-flex class="mb-12" text-center style="color: white">
                    <img src="../../assets/img/logo/logo-lpn.jpg" height="150"/>
                    <p class="font-weight-light mt-8">{{ nt_tname }}</p>
                    <p v-if="!progress && showData" class="headline font-weight-bold mt-4">แจ้งรับพัสดุนอกเวลา</p>
                    <p v-if="!progress && !showData && !rentRoom" class="headline font-weight-bold mt-4">
                        ไม่มีรายการพัสดุ</p>
                    <p v-if="!progress && rentRoom" class="headline font-weight-bold mt-4">ไม่พบห้องที่เช่า</p>
                </v-flex>
                <v-flex class="mt-12">
                    <div class="text-center pt-12" v-if="progress">
                        <v-progress-circular
                            :rotate="2"
                            :size="150"
                            :width="10"
                            color="white"
                            indeterminate>
                        </v-progress-circular>
                    </div>
                    <div class="my-2" v-for="(item, index) in items[0]" :key="index" v-if="!progress && showData">
                        <v-card class="mx-auto my-2"
                                @click="selectedParcel(items[0], index, item.SU_RUNNO)"
                                v-if="item.SU_STATUS === 'S' || item.SU_STATUS === 'E'"
                                style="border-left:solid 8px #69C7F0;background: #f3f4f6">
                            <v-row>
                                <v-col class="text-center my-auto" cols="3">
                                    <v-icon large color="blue darken-2">mdi-package-variant-closed</v-icon>
                                    <br/>
                                    <span v-if="item.SU_STATUS === 'S'"
                                          class="overline font-weight-bold"
                                          style="color: #0045AF">รอรับ</span>
                                    <span v-if="item.SU_STATUS === 'E'"
                                          class="overline font-weight-bold"
                                          style="color: #0045AF">เกินกำหนด</span>
                                </v-col>
                                <v-col cols="7">
                                    <v-card-title><b>พัสดุคุณ {{ item.SU_FULLNAME }}</b></v-card-title>
                                    <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }}</v-card-text>
                                    <v-card-text>เลขที่อ้างอิง : {{ item.SU_CODE }}</v-card-text>
                                    <v-card-text style="color: #ff2e34">เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                                </v-col>
                                <v-col cols="2" class="text-center my-auto pr-3">
                                    <v-icon v-if="item.CLICK == 1" large color="green darken-3">mdi-check-bold
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mx-auto my-2"
                                v-if="item.SU_STATUS === 'W'"
                                style="border-left:solid 8px #69C7F0;background: #f3f4f6">
                            <v-row>
                                <v-col class="text-center my-auto" cols="3">
                                    <v-icon large color="blue darken-2">mdi-package-variant-closed</v-icon>
                                    <br/>
                                    <span v-if="item.SU_STATUS === 'W'"
                                          class="overline font-weight-bold"
                                          style="color: #0045AF">นอกเวลา</span>
                                </v-col>
                                <v-col cols="7">
                                    <v-card-title><b>พัสดุคุณ {{ item.SU_FULLNAME }}</b></v-card-title>
                                    <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }}</v-card-text>
                                    <v-card-text>เลขที่อ้างอิง : {{ item.SU_CODE }}</v-card-text>
                                    <v-card-text style="color: #ff2e34">เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                                </v-col>
                            </v-row>
                        </v-card>
                    </div>
                    <div v-if="!progress && showData" class="mt-8">
                        <v-btn color="#2E7D32"
                               block
                               large
                               dark
                               @click="check()">
                            ยืนยันรับพัสดุนอกเวลา
                        </v-btn>
                    </div>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">ไม่มีรายการที่เลือก</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="dialog = false">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog2" persistent max-width="600px">
            <v-card>
                <v-card-text class="pt-10">
                    <v-menu ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            style="padding: 0">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="date"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          label="วันที่รับพัสดุ"></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title scrollable :min="dateMin" :max="dateMax">
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="save()">
                        ตกลง
                    </v-btn>
                    <v-btn color="red darken-1"
                           text
                           @click="dialog2 = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog3" max-width="290">
            <v-card>
                <v-card-title>แจ้งรับพัสดุนอกเวลาเรียบร้อยแล้ว</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="reload()">
                        ยืนยัน
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from '@/axios';
import axios_line from '@/axios_line';
import EventBus from '@/EventBus'

export default {
    name: "OTParcelCustomer",
    data() {
        return {
            items: [],
            nt_tname: null,
            lineID: this.$route.params.lineID,
            channelID: this.$route.params.channelID,
            searchText: '',
            itemSelected: [],
            phoneNum: '',
            progress: true,
            showData: false,
            dialog: false,
            dialog2: false,
            dialog3: false,
            date: new Date().toISOString().substr(0, 10),
            dateMin: new Date().toISOString().substr(0, 10),
            menu: false,
            timer: '',
            disable: true,
            unit: true,
            OTPbtn: false,
            debug: '',
            rentRoom: false
        }
    },
    computed: {
        dateMax() {
            let date = new Date();
            date.setDate(date.getDate() + 7);
            return date.toISOString().substr(0, 10)
        }
    },
    mounted() {
        window.scrollTo(0, 0)
        this.getDataLine()
    },
    methods: {
        reload() {
            this.dialog3 = false
            this.progress = true
            this.showData = false
            this.items = []
            this.getDataLine()
        },
        async getDataLine() {
            try {
                axios_line.post('/getCustomerInfoByLineIDV2', {
                    lineID: this.lineID,
                    channelID: this.channelID
                }, {
                    auth: {
                        username: 'lpn-line-@2020',
                        password: 'aj29fd8vcjn4k43012w98sdj2'
                    }
                })
                    .then(res => {
                        if (res.data.data.rent_rooms) {
                            let dataLine = res.data.data.rent_rooms
                            console.log('dataLine', dataLine)
                            this.nt_tname = dataLine[0].tmCOM_fcName.replace('นิติบุคคลอาคารชุด ', '').replace('นิติฯ ', '')
                            this.phoneNum = res.data.data.CR_PHONE_NUMBER
                            this.getParcelList(dataLine[0])
                            // this.nt_tname = 'ลุมพินี ทาวน์ชิป รังสิต-คลอง 1 เอฟ จี'
                            // this.phoneNum = '0643144164'
                            // this.getParcelList('')
                            // dataLine.forEach(function (value) {
                            //     this.getParcelList(value)
                            // })
                        } else {
                            this.progress = false
                            this.rentRoom = true
                        }
                    })
            } catch (err) {
                console.log(err.message)
            }
        },
        async getParcelList(value) {
            let searchData = {
                searchText: value.tmRoomH_fcAddressNo,
                nt_runno: value.CPR_IPROP_CODE,
                type: "cus",
            }
            // let searchData = {
            //     searchText: '121/15',
            //     nt_runno: 'TEST',
            //     type: 'cus',
            // }
            try {
                axios.post('/WaitParcelList', searchData)
                    .then(res => {
                        console.log('ParcelList', res.data.data)
                        if (res.data.data.length > 0) {
                            this.showData = true
                            this.items.push(res.data.data)

                            let itemDefault = this.itemSelected

                            res.data.data.forEach(function (value) {
                                if (value.SU_STATUS === 'S' || value.SU_STATUS === 'E' || value.SU_STATUS === 'W') {
                                    // console.log('items', value.SU_RUNNO)
                                    itemDefault.push(value.SU_RUNNO)
                                }
                            })
                            this.itemSelected = itemDefault
                        }
                        this.progress = false
                    })
            } catch (err) {
                console.log(err.message)
            }
        },
        async saveOTParcel(itemSelected, date) {
            try {
                let phoneNum = this.phoneNum
                itemSelected.forEach(function (su_runno) {
                    axios.post('/SaveParcelOT', {su_runno: su_runno, dateOT: date, username: phoneNum})
                        .then(res => {
                            console.log('SaveParcelOT', res.data)
                        })
                    // console.log('SaveParcelOT', su_runno)
                })
                this.dialog2 = false
                this.dialog3 = true
            } catch (err) {
                console.log(err.message)
            }
        },
        save() {
            console.log('save', 'OK')
            this.saveOTParcel(this.itemSelected, this.date)
        },
        check() {
            if (this.itemSelected.length === 0) {
                this.dialog = true
            } else {
                this.dialog2 = true
            }
        },
        selectedParcel(array, index, data) {
            if (array[index].CLICK == '1') {
                array[index].CLICK = '0'
                this.removeItem(this.itemSelected, data)
            } else {
                array[index].CLICK = '1'
                this.itemSelected.push(data)
            }
            console.log('selectedParcel', this.itemSelected)
        },
    },
}
</script>

